import { useNavigate } from 'react-router-dom';

import { Button, Paragraph, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { ProposalDetailsContainerStyled } from './style';

type JobInformationPropTypes = {
  _id?: string;
  createdAt?: string;
  jobTitle?: string;
  notes?: string;
  pricing?: string;
};

const JobInformation = ({
  createdAt,
  jobTitle,
  notes,
  pricing,
  _id,
}: JobInformationPropTypes) => {
  const navigate = useNavigate();
  return (
    <ProposalDetailsContainerStyled>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="normal"
          strong
          fontColor="secondary"
          className="section-title"
        >
          JOB INFORMATION
        </Typography>
        <Button onClick={() => navigate(`/browse-jobs/${_id}`)}>
          View Job
        </Button>
      </div>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Job Create At :
          </Typography>
          <Typography className="value">{createdAt}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Job Title :
          </Typography>
          <Typography className="value">{jobTitle}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title" fontColor="dark">
            Pricing :
          </Typography>
          <Typography className="value">{pricing}</Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title" fontColor="dark">
            Notes :
          </Typography>
          <div className="value">
            <Paragraph text={notes} />
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ProposalDetailsContainerStyled>
  );
};

export default JobInformation;
